// import Cookies from 'js-cookie'
import Cookies from 'vue-cookies'

export function getCookies (Name) {
  return Cookies.get(Name)
}
export function setCookies (Name, value) {
  return Cookies.set(Name, value, { expires: 1 })
}

export function removeCookies (Name) {
  return Cookies.remove(Name)
}

export function setCookiesWithExpire (Name, value, day) {
  return Cookies.set(Name, value, day + 'd')
}

export function setCookiesWithDomainExpire (Name, value, day, domain) {
  document.cookie = Name + '=' + value + ';expires=' + day + ';domain=' + domain
  // return Cookies.set(Name, value, { expires: day, domain: domain })
}
